const sanityConfig = { projectId: "zzw4zduo", dataset: "production" };
export default sanityConfig;
